import React, { Component } from "react";

import Ink from "react-ink";
import {Slide} from "react-awesome-reveal";
import WebShare from "../WebShare";
import withRouter from "../../../withRouter";
class BackWithSearch extends Component {
	handleBack = () => {
		const { navigate, fallbackPath } = this.props;

		// window.history.length <= 1 means deep link / external entry
		const hasHistory = window.history.length > 1;

		if (hasHistory) {
			navigate(-1);
			return;
		}

		navigate(fallbackPath || "/");
	};
	componentDidMount() {
		sessionStorage.removeItem("tranzila_session_v1")
	}
	
	render() {
		return (
			<React.Fragment>
				<div className="col-12 p-0 fixed" style={{ zIndex: "9" }}>
					<div className="block m-0">
						<div className={`block-content p-0 ${this.props.dark && "nav-dark"}`}>
							<div className={`input-group ${this.props.boxshadow && "search-box"}`}>
								{!this.props.disable_back_button && (
									<div className="input-group-prepend">
										{this.props.back_to_home && (
											<button
												type="button"
												className="btn search-navs-btns"
												style={{ position: "relative" }}
												onClick={() => {
													setTimeout(() => {
														this.handleBack();
													}, 200);
												}}

											>
												<i className="si si-arrow-left" />
												<Ink duration="500" />
											</button>
										)}

										{this.props.goto_orders_page && (
											<button
												type="button"
												className="btn search-navs-btns"
												style={{ position: "relative" }}
												onClick={() => {
													setTimeout(() => {
														this.props.navigate("/my-orders");
													}, 200);
												}}
											>
												<i className="si si-arrow-left" />
												<Ink duration="500" />
											</button>
										)}
										{this.props.goto_accounts_page && (
											<button
												type="button"
												className="btn search-navs-btns"
												style={{ position: "relative" }}
												onClick={() => {
													setTimeout(() => {
														this.props.navigate("/my-account");
													}, 200);
												}}
											>
												<i className="si si-arrow-left" />
												<Ink duration="500" />
											</button>
										)}
										{!this.props.back_to_home &&
											!this.props.goto_orders_page &&
											!this.props.goto_accounts_page && (
												<button
													type="button"
													className={`btn search-navs-btns ${this.props.dark && "nav-dark"}`}
													style={{ position: "relative" }}
													onClick={() => {
														setTimeout(() => {
															if (this.props.onBackClick) {
																this.props.onBackClick();
															} else {
																this.handleBack();
															}
														}, 200);
													}}
												>
													<i className="si si-arrow-left" />
													<Ink duration="500" />
												</button>
											)}
									</div>
								)}
								<p
									className={`form-control search-input d-flex align-items-center ${this.props.dark &&
										"nav-dark"}`}
								>
									{this.props.logo && (
										<img
											src="/assets/img/logos/logo.png"
											alt={localStorage.getItem("storeName")}
											width="120"
										/>
									)}
									{this.props.has_title ? (
										<React.Fragment>
											{this.props.from_checkout ? (
												<span className="nav-page-title">
													{localStorage.getItem("cartToPayText")}{" "}
													<span style={{ color: localStorage.getItem("storeColor") }}>
														{localStorage.getItem("currencySymbolAlign") === "left" &&
															localStorage.getItem("currencyFormat")}
														{this.props.title}
														{localStorage.getItem("currencySymbolAlign") === "right" &&
															localStorage.getItem("currencyFormat")}
													</span>
												</span>
											) : (
												<span className="nav-page-title">{this.props.title}</span>
											)}
										</React.Fragment>
									) : null}
									{this.props.has_delivery_icon && (
										<Slide direction="left">
											<img
												src="/assets/img/various/delivery-bike.png"
												alt={this.props.title}
												className="nav-page-title"
											/>
										</Slide>
									)}
								</p>
								{this.props.has_restaurant_info ? (
									<div
										className="fixed-restaurant-info hidden"
										ref={(node) => {
											this.heading = node;
										}}
									>
										<span className="font-w700 fixedRestaurantName">
											{this.props.restaurant.name}
										</span>
										<br />
										<span className="font-w400 fixedRestaurantTime">
											<i className="si si-clock" /> {this.props.restaurant.delivery_time}{" "}
											{localStorage.getItem("homePageMinsText")}
										</span>
									</div>
								) : null}
								<div className="input-group-append">
									{!this.props.disable_search && (
										<button
											type="submit"
											className="btn search-navs-btns"
											style={{ position: "relative" }}
										>
											<i className="si si-magnifier" />
											<Ink duration="500" />
										</button>
									)}
									{this.props.homeButton && (
										<button
											type="button"
											className="btn search-navs-btns nav-home-btn"
											style={{ position: "relative" }}
											onClick={() => {
												setTimeout(() => {
													this.props.navigate("/");
												}, 200);
											}}
										>
											<i className="si si-home fa-2x text-muted" />
											<Ink duration="500" />
										</button>
									)}
									{this.props.shareButton && <WebShare link={window.location.href} />}
								</div>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default withRouter(BackWithSearch);
